export default __webpack_public_path__ + "static/media/plain-sticker-M.ccef1d8a.png";